import { render, staticRenderFns } from "./losaprily-images-grid.vue?vue&type=template&id=13d8b916&scoped=true&"
import script from "./losaprily-images-grid.vue?vue&type=script&lang=js&"
export * from "./losaprily-images-grid.vue?vue&type=script&lang=js&"
import style0 from "./losaprily-images-grid.vue?vue&type=style&index=0&id=13d8b916&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d8b916",
  null
  
)

export default component.exports